<template>
    <form-row title="Can the closing be extended?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="can_extend_closing"
                v-model="can_extend_closing"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            can_extend_closing: this.commercial.can_extend_closing,
        }
    },
}
</script>
